/**
 * Toast notifications store (Svelte 5 writable).
 * Pages push toasts via toast.success/error/info; <Toaster /> renders them.
 */

import { writable } from 'svelte/store'

export type ToastKind = 'success' | 'error' | 'info'

export interface ToastAction {
  label: string
  run: () => void
}

export interface Toast {
  id: number
  kind: ToastKind
  message: string
  action?: ToastAction
}

export const toasts = writable<Toast[]>([])
let nextId = 1

function push(kind: ToastKind, message: string, timeoutMs: number, action?: ToastAction): void {
  const toast: Toast = action ? { id: nextId++, kind, message, action } : { id: nextId++, kind, message }
  toasts.update((list) => [...list, toast])
  if (timeoutMs > 0) {
    setTimeout(() => removeToast(toast.id), timeoutMs)
  }
}

export function removeToast(id: number): void {
  toasts.update((list) => list.filter((t) => t.id !== id))
}

export const toast = {
  success: (message: string, timeoutMs = 4000, action?: ToastAction) =>
    push('success', message, timeoutMs, action),
  error: (message: string, timeoutMs = 6000, action?: ToastAction) =>
    push('error', message, timeoutMs, action),
  info: (message: string, timeoutMs = 4000, action?: ToastAction) =>
    push('info', message, timeoutMs, action),
}
